import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
import { Box } from "@chakra-ui/react"
import { ClientLayout, DealManagerLayout } from "@/layouts"
import {
  CompliancePage,
  DealsPage,
  DealManagerDealPage,
  DocumentsPage,
  LoginPage,
  NdaPage,
  PaymentCenterPage,
  ResourcesPage,
  TaxesPage,
  CompanyPage,
  DealPipelinePage,
  EmployeeOutreachPage,
  CommissionsPage,
  ReportsPage,
  PitchbookPage,
  PitchbookInvestorPage,
  SettingsPage,
  HotlistPage,
  FmvReviewPage,
  FmvStagingPage,
  PortalExtractionPage,
  StrandedValuePage,
  ActivityPage,
} from "@/pages"
import { PortalRole } from "@/types"
import { ProtectedRoute } from "./ProtectedRoute"
import { IrrPage } from "@pages/IrrPage"

export const Router = () => {
  return (
    <Box>
      <BrowserRouter>
        <Routes>

          {/* Public */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/nda" element={<NdaPage />} />
          {/* Client App */}
          <Route
            path="/client"
            element={
              <ClientLayout />
            }
          >
            <Route path="deals" element={<DealsPage />} />
            <Route path="documents" element={<DocumentsPage />} />
            <Route path="compliance" element={<CompliancePage />} />
            <Route path="resources" element={<ResourcesPage />} />
            <Route path="taxes" element={<TaxesPage />} />
            <Route path="payment" element={ <PaymentCenterPage /> } />
          </Route>

          {/* Deal Manager App */}
          <Route
            path="/core"
            element={
              <ProtectedRoute allowedRoles={[PortalRole.ESO_PERSON]}>
                <DealManagerLayout />
              </ProtectedRoute>
            }
          >
            <Route path="pipeline" element={<DealPipelinePage />} />
            <Route path="hotlist" element={<HotlistPage />} />
            <Route path="fmv_review" element={<FmvReviewPage />} />
            <Route path="fmv_staging/:id" element={<FmvStagingPage />} />
            <Route path="irr" element={<IrrPage />} />
            <Route path="employee_outreach" element={<EmployeeOutreachPage />} />
            <Route path="commissions" element={<CommissionsPage />} />
            <Route path="reports" element={<ReportsPage />} />
            <Route path="company/:companyId" element={<CompanyPage />} />
            <Route path="deal/:dealId" element={<DealManagerDealPage />} />
            <Route path="pitchbook/company/:companyId" element={<PitchbookPage />} />
            <Route path="pitchbook/investor/:pbInvestorId" element={<PitchbookInvestorPage />} />
            <Route path="portal_extraction" element={<PortalExtractionPage />} />
            <Route path="stranded_value" element={<StrandedValuePage />} />
            <Route path="activity" element={<ActivityPage />} />
            <Route path="settings" element={<SettingsPage />} />
          </Route>

          <Route path="*" element={<Navigate to="/login" />} />
        </Routes>
      </BrowserRouter>
    </Box>
  )
}